// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("../types/TypeUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function fromString(str) {
  if (str.startsWith("cus_")) {
    return str;
  }
  
}

var include = TypeUtils.MakeCustomOpaqueStringType({
      fromString: fromString,
      toString: Relude_Globals.id
    });

var fromString$1 = include.fromString;

var toString = include.toString;

function toStripeUrl(param) {
  return Relude_Globals.$great$great(toString, (function (param) {
                return "https://dashboard.stripe.com/customers/" + param;
              }), param);
}

function parse(param) {
  return Relude_Globals.$great$great(fromString$1, Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: toString
};

var Id_decode = include.decode;

var Id_encode = include.encode;

var Id_compare = include.compare;

var Id_eq = include.eq;

var Id_Ord = include.Ord;

var Id_Set = include.$$Set;

var Id_Map = include.$$Map;

var Id = {
  fromString: fromString$1,
  toString: toString,
  decode: Id_decode,
  encode: Id_encode,
  compare: Id_compare,
  eq: Id_eq,
  Ord: Id_Ord,
  $$Set: Id_Set,
  $$Map: Id_Map,
  toStripeUrl: toStripeUrl,
  GraphQL_API: GraphQL_API
};

function fromString$2(str) {
  if (str.startsWith("ba_")) {
    return {
            TAG: /* ACH */1,
            _0: str
          };
  } else if (str.startsWith("card_")) {
    return {
            TAG: /* CreditCard */0,
            _0: str
          };
  } else {
    return ;
  }
}

function toString$1(str) {
  return str._0;
}

var include$1 = TypeUtils.MakeCustomOpaqueStringType({
      fromString: fromString$2,
      toString: toString$1
    });

var fromString$3 = include$1.fromString;

var toString$2 = include$1.toString;

var decode = include$1.decode;

var encode = include$1.encode;

function toPaymentType(param) {
  if (param.TAG === /* CreditCard */0) {
    return /* StripeCC */0;
  } else {
    return /* StripeACH */1;
  }
}

function toPaymentType$1(param) {
  return Relude_Globals.$great$great((function (prim) {
                return prim;
              }), toPaymentType, param);
}

function isACH(param) {
  return Relude_Globals.$great$great(toPaymentType$1, (function (param) {
                if (typeof param === "number") {
                  return param === 1;
                } else {
                  return false;
                }
              }), param);
}

function isCreditCard(param) {
  return Relude_Globals.$great$great(toPaymentType$1, (function (param) {
                if (typeof param === "number") {
                  return param === 0;
                } else {
                  return false;
                }
              }), param);
}

function parse$1(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(decode, Relude_Result.toOption, param);
              }), Relude_Option.getOrThrow, param);
}

var GraphQL_API$1 = {
  parse: parse$1,
  serialize: encode
};

var Source_compare = include$1.compare;

var Source_eq = include$1.eq;

var Source_Ord = include$1.Ord;

var Source_Set = include$1.$$Set;

var Source_Map = include$1.$$Map;

var Source = {
  fromString: fromString$3,
  toString: toString$2,
  decode: decode,
  encode: encode,
  compare: Source_compare,
  eq: Source_eq,
  Ord: Source_Ord,
  $$Set: Source_Set,
  $$Map: Source_Map,
  toPaymentType: toPaymentType$1,
  isACH: isACH,
  isCreditCard: isCreditCard,
  GraphQL_API: GraphQL_API$1
};

function make(prim, prim$1) {
  var tmp = {};
  if (prim !== undefined) {
    tmp.email = Caml_option.valFromOption(prim);
  }
  return tmp;
}

var Payload = {
  make: make
};

function make$1(prim) {
  return {
          id: prim
        };
}

var $$Response = {
  make: make$1
};

var Create = {
  Payload: Payload,
  $$Response: $$Response
};

function make$2(prim, prim$1) {
  var tmp = {};
  if (prim !== undefined) {
    tmp.source = Caml_option.valFromOption(prim);
  }
  return tmp;
}

var Payload$1 = {
  make: make$2
};

function make$3(prim) {
  return {
          id: prim
        };
}

var $$Response$1 = {
  make: make$3
};

var Update = {
  Payload: Payload$1,
  $$Response: $$Response$1
};

var partial_arg = Curry._1(Relude_Option.flatMap, fromString$3);

var partial_arg$1 = Curry._1(Relude_Option.flatMap, (function (prim) {
        if (prim == null) {
          return ;
        } else {
          return Caml_option.some(prim);
        }
      }));

function partial_arg$2(param) {
  return Relude_Globals.$great$great((function (prim) {
                return Caml_option.undefined_to_opt(prim.default_source);
              }), partial_arg$1, param);
}

function defaultPaymentSourceGet(param) {
  return Relude_Globals.$great$great(partial_arg$2, partial_arg, param);
}

function make$4(defaultPaymentSource) {
  var arg = Relude_Option.map((function (param) {
          return Relude_Globals.$great$great(toString$2, (function (prim) {
                        return prim;
                      }), param);
        }), defaultPaymentSource);
  return function (param) {
    return function (param$1) {
      var tmp = {
        id: param
      };
      if (arg !== undefined) {
        tmp.default_source = Caml_option.valFromOption(arg);
      }
      return tmp;
    };
  };
}

exports.Id = Id;
exports.Source = Source;
exports.Create = Create;
exports.Update = Update;
exports.defaultPaymentSourceGet = defaultPaymentSourceGet;
exports.make = make$4;
/* include Not a pure module */
